import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const CropStageMasterList = lazy(() => import('../../pages/crop_management/crop_stage_master/CropStageMasterList'));
const CropScheduleVariantList = lazy(() => import('../../pages/crop_management/crop_schedule_variant/CropScheduleVariantList'));
const DayWiseScheduleList = lazy(() => import('../../pages/crop_management/day_wise_schedule/DayWiseScheduleList'));
const AddDayWiseSchedule = lazy(() => import('../../pages/crop_management/day_wise_schedule/AddDayWiseSchedule'));
const UpdateDayWiseSchedule = lazy(() => import('../../pages/crop_management/day_wise_schedule/UpdateDayWiseSchedule'));
const DayWiseScheduleDetails = lazy(() => import('../../pages/crop_management/day_wise_schedule/DayWiseScheduleDetails'));

export const CropManagementImport = {
    RoutesMap,
    CropStageMasterList,
    CropScheduleVariantList,
    DayWiseScheduleList,
    AddDayWiseSchedule,
    UpdateDayWiseSchedule,
    DayWiseScheduleDetails,
}
